import { h, Component } from 'preact';
import { Router } from 'preact-router';

import { Banner } from 'lib/mkjs';
import MkApp from 'lib/mkjs/app';

import Header from 'components/header';
import { getRouterPages } from 'components/pages';
import { AcceptConnectionRequest } from 'components/elements/connectionrequest';
import Footer from 'components/footer';


import MkApi from 'lib/townshend/api/mkapi';
//TODO add sample custom api(s)

//TODO add sample entity/ies

import ContentItem from 'lib/mkjs/contentitem';
import ContactEntity from "entities/contactentity";
import ContactIdentity from "entities/contactidentity";
import ContactIdentityVerification from "entities/contactidentityverfication";
import ContactImport from "entities/contactimport";
import ContactInfo from "entities/contactinfo";
import ContactInfoChangeEvent from "entities/contactinfochangeevent";
import Connection from "entities/connection";
import ConnectionRequest from "entities/connectionrequest";
import GraphEvent from "entities/graphevent";
import style from './app/style.less';

export default class App extends MkApp {

	constructor(props) {
		//TODO determine the best place to inject this
		let baseUrl = (process.env.NODE_ENV==='production') ? 'https://addyapp.com' : "http://localhost:8080"
		let apiBaseUrl = baseUrl + "/api";
		let oauthBaseUrl = baseUrl + "/oauth";

		if (process.env.NODE_ENV == 'development') {
			let oldLink = document.querySelector("link[rel*='icon']");
			let link = document.createElement('link');
			link.type = 'image/png';
			link.rel = 'shortcut icon';
			link.href = '/assets/icons/favicon-32x32.invert.png';
			document.getElementsByTagName('head')[0].appendChild(link);
			if (oldLink) {
				document.head.removeChild(oldLink);
			}
			document.head.appendChild(link);
		}

		props = Object.assign(props, {
			requestInviteFields: {
				"name" : {
					"type" : "string"
				},
				"source" : {
					"type" : "string",
					"title": "How did you find us?",
					"enum" : ["Friend or Family", "Advertisement", "Other"]
				},
				"otherSource" : {
					"type" : "string",
					"title": "Please Specify",
					"if" : {
						"source": {
							"enum": ["Other"]
						}
					}
				},
			},
			requestInviteIntro: `<p class="lead">Addy is coming soon to solve all your address issues.</p>
<p>Secure a spot on the waitlist for Addy and we'll let you know as soon as it's available.</p>`,
			requestInviteIntroType: 'html',
			env: process.env.NODE_ENV
		}, {
			apiBaseUrl,
			oauthBaseUrl
		})
		console.log('App.constructor', props);
		super(props, {
			"contactEntity"  : new MkApi(props, '/contact-entities'),
			"contactIdentity"  : new MkApi(props, '/contact-identities'),
			"contactIdentityVerification"  : new MkApi(props, '/contact-identity-verifications'),
			"contactImport"  : new MkApi(props, '/contact-imports'),
			"contactInfo"  : new MkApi(props, '/contact-infos'),
			"contactInfoChangeEvent"  : new MkApi(props, '/contact-info-change-events'),
			"connection"  : new MkApi(props, '/connections'),
			"connectionRequest"  : new MkApi(props, '/connection-requests'),
			"graphEvent"  : new MkApi(props, '/graph-events'),
		}, {
			"contact-entities": ContactEntity,
			"contact-identities": ContactIdentity,
			"contact-identity-verifications"  : ContactIdentityVerification,
			"contact-imports": ContactImport,
			"contact-infos": ContactInfo,
			"contact-info-change-events": ContactInfoChangeEvent,
			"connections": Connection,
			"connection-requests": ConnectionRequest,
			"graph-events": GraphEvent,
		});

	}

	loadCurrentUser(callback) {
		let addyCallback = (state)=> {
			//TODO fetch entities for this user and keep in state or put into local storage.
			this.setState({
				contactEntity: null,
				isLoadingContactEntity: true
			});
			//TODO fetch entities for which user is delegate as well;
			this.apis.contactEntity.list({
				'primaryUser.id': state.currentUser.id
			}).then(entities=>{
				//TODO handle error
				//TODO allow switching between entities for now just use the first one.
				this.setState({
					contactEntity: entities.length == 0 ? false : entities[0],
					isLoadingContactEntity: false
				})
			}).catch(error => {
				console.error("fetch entities error", error);
				this.setState({
					isLoadingContactEntity: false
				})
			});
			if (callback) {
				callback(this.state);
			}
		}
		return super.loadCurrentUser(addyCallback);
	}

	getPermanentTitle() {
		return this.props.env == 'development' ? 'Addy.dev' : 'Addy';
	}

	render() {
		let props = this.routeProps();

		props.contactEntity = this.state.contactEntity;
		props.isLoadingContactEntity = this.state.isLoadingContactEntity;
		props.env = this.props.env;
		//TODO create an object that maps from the classname to a function mapping an instance to the canonical path
		//and add that object to props
		let routes = this.routes();

		return (
			<div id="app">
				<Header {...props} onLogout={this.onLogout} currentUrl={this.state.currentUrl} entities={this.getApplicationEntities()}/>
				<div class={style.app_content_less}>
					<div class="container-fluid app-content">
						<Banner {...this.state.banner}/>
						<Router onChange={this.handleRoute}>
							{ getRouterPages(props, ()=>this.loadCurrentUser(), this.success) }
							{routes}
							<AcceptConnectionRequest {...props} path="/r/:connectionRequestId/:connectionRequestCode"
								onLogin={()=>this.onLogin(null)}
								onCreate={(subject, item)=>this.onCreateAccount(subject, item, null)}
								onAccept={()=>{this.loadCurrentUser(()=>this.success('You have accepted the connection request.', '/'))}} />
							<ContentItem {...props} default />
						</Router>
					</div>
					<Footer {...props} />
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./components/app.js